import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Layout, AppRoutes, ScrollToTop } from './components';
import { JWTAuthProvider } from './components/JWTAuthContext.js';
import { getGoogleOAuthConfig } from './components/apiConfig.js';
import { ChatWidget } from './components/help-chatbot';
import './styles/App.css';

function App() {
  const googleConfig = getGoogleOAuthConfig();
  
  return (
    <GoogleOAuthProvider clientId={googleConfig.clientId}>
      <JWTAuthProvider>
        <Router>
          <ScrollToTop />
          {/* <HighlighterBanner /> */}
          <Layout>
            <AppRoutes />
          </Layout>
          
          {/* Help Chatbot - Floats over all content */}
          <ChatWidget />
        </Router>
      </JWTAuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
